<template>
    <div>
        <div class="table-header row">
            <!-- <div>
                状态
            </div> -->
            <div>
                网吧名称/网吧ID
            </div>
            <div>外网IP</div>
            <div>服务器</div>
            <div>客户机</div>
            <div>路由器</div>
            <div>授权验证端口</div>
            <div>远程代理端口</div>
            <div>授权剩余时间</div>
            <div>上次远程时间</div>
            <div>操作</div>
        </div>
        <div class="table-body">
            <div class="row" v-for="(item, index) in serverList" :key="index">
                <!-- 选中 -->
                <!-- <div>
                    <img src=@/assets/img/icon/u728.png />
                </div> -->
                <!-- 网吧名以及id -->
                <div class="bar-name">
                    <p v-text="item.barName"></p>
                    <p v-text="item.barId"></p>
                </div>
                <!-- 外网ip -->
                <div>
                    <span
                        v-show="item.expireTime != 0"
                        v-text="$PropFn.safeDislayValue(item.wanIp)"
                    ></span>
                    <span v-show="item.expireTime == 0">--</span>
                </div>
                <!-- 服务器 -->
                <div class="server">
                    <!-- <span v-show="item.expireTime==0">--</span> -->
                    <div
                        :class="{
                            online: item.bsOnline > 0,
                            offline: item.bsOnline == 0
                        }"
                    >
                        <!-- 在线的icon -->
                        <img src=@/assets/img/icon/u422.png
                        v-show="item.bsOnline>0" />
                        <!-- 离线的icon -->
                        <img src=@/assets/img/icon/u424.png
                        v-show="item.bsOnline==0" />
                        <span>
                            在线
                        </span>
                        <span v-text="item.bsOnline"></span>
                        <span>/</span>
                        <span v-text="item.bsSum"></span>
                    </div>
                </div>
                <!-- 客户机在线数/总数 -->
                <div>
                    <!-- <span v-show="item.expireTime==0">--</span> -->
                    <span v-text="item.bcOnline"></span>
                    <span>/</span>
                    <span v-text="item.bcSum"></span>
                </div>
                <!-- 路由器总数 -->
                <div>
                    <!-- <span v-show="item.expireTime==0">--</span> -->
                    <span
                        v-text="$PropFn.safeDislayValue(item.remotingCnt)"
                    ></span>
                </div>
                <!-- 授权验证端口 -->
                <div>
                    <!-- <span v-show="item.expireTime==0">--</span> -->
                    <span
                        :class="{ 'gray-word': !$PropFn.hasValue(item.vport) }"
                        v-text="$PropFn.safeDislayValue(item.vport, '未设置')"
                    ></span>
                </div>

                <!-- 远程代理端口 -->
                <div>
                    <!-- <span v-show="item.expireTime==0">--</span> -->
                    <span
                        :class="{ 'gray-word': !$PropFn.hasValue(item.pport) }"
                        v-text="$PropFn.safeDislayValue(item.pport, '未设置')"
                    ></span>
                </div>
                <!-- 授权剩余时间 -->
                <div>
                    <span v-show="item.expireTime == 0">已过期</span>
                    <span
                        v-show="item.expireTime != 0"
                        v-text="calcMinSecond(item.expireTime, true)"
                    ></span>
                </div>
                <!-- 上次远程时间 -->
                <div>
                    <span
                        v-text="showDate('Y-M-D h:m:s', item.remoteTime)"
                    ></span>
                </div>
                <div class="operate">
                    <a
                        href="#"
                        v-show="item.expireTime != 0"
                        @click.prevent="toBar(item)"
                        >远程</a
                    >
                    <a href="#" @click.prevent="showModals(item)">删除记录</a>
                </div>
            </div>
            <no-data
                style="height:auto;padding-top:20px;padding-bottom:20px;"
                v-show="tableList.length == 0 || loading"
                :nodata="tableList.length == 0 && !loading"
                :loading="loading"
            ></no-data>
        </div>
    </div>
</template>

<script>
// 更多悬浮
import { delRemoteRecord } from "@/requests/bar";
import NoData from "_c/noData/noData";
import { mapActions } from "vuex";
import { showDate, calcMinSecond } from "@/utils/time";
export default {
    name: "tableData",
    components: {
        NoData
    },
    props: {
        tableList: {
            type: Array,
            default() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isSelectAll: false,
            serverList: []
        };
    },
    watch: {
        tableList() {
            this.serverList = this.tableList;
        }
    },
    methods: {
        ...mapActions(["barDetails/actionUpdateBarAdminInfo"]),
        showDate,
        calcMinSecond,
        toBar(item) {
            if (item.expireTime != 0) {
                this.$router.push({
                    path: `${this.$PAGE_API.home.children.barManager.children.index.children.barDetails.path}/${item.barId}?isSelf=2`
                });
            }
        },
        showModals(item) {
            window.$Message.show({
                title: "是否删除",
                type: "success",
                msg: "你确认删除该记录么",
                cancleBtn: true,
                confirmFn: () => {
                    this.del(item);
                    window.$Message.hide();
                }
            });
        },
        async del(item) {
            let res = await delRemoteRecord(item.barRemoteHistoryId);
            if (res.code == 200) {
                this.$emit("updateTable");
                this["barDetails/actionUpdateBarAdminInfo"]();
            } else {
                window.$Message.show({
                    title: "删除远程协助记录",
                    type: "error",
                    msg: res.msg
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.row {
    width: 100%;
    @include clearfix();
    cursor: pointer;
    > div {
        float: left;
        text-align: left;
        text-overflow: ellipsis;
        height: 50px;

        span {
            @include ellipsis();
            display: inline-block;
            max-width: 100%;
        }
        p {
            @include ellipsis();
            max-width: 100%;
        }
        a {
            text-align: left;
            text-indent: 0px;
            margin-right: 8px;
            color: #0066cc;
        }
        input {
            cursor: pointer;
        }
    }
    .more-btn {
        margin-left: 0;
    }

    // > div:nth-child(1) {
    //     width: 5%;
    //     text-indent: 10px;
    // }
    > div:nth-child(1) {
        width: 12%;
        text-indent: 10px;
    }
    > div:nth-child(2) {
        width: 8%;
    }
    > div:nth-child(3) {
        width: 8%;
    }
    > div:nth-child(4) {
        width: 6%;
    }
    > div:nth-child(5) {
        width: 6%;
    }
    > div:nth-child(6) {
        width: 10%;
    }
    > div:nth-child(7) {
        width: 10%;
    }
    > div:nth-child(8) {
        width: 10%;
    }
    > div:nth-child(9) {
        width: 12%;
    }
}

.table-header {
    > div {
        height: 30px;
        line-height: 30px;
    }
}
.gray-word {
    color: $gray-word;
}
.bar-name,
.computer-name,
.ip-name {
    p {
        line-height: normal;
        line-height: 14px;
    }
    p:nth-child(1) {
        padding-top: 10px;
    }
}
.computer-name {
    p:nth-child(1) {
        color: $blue-1;
    }
}

.server {
    .online {
        span {
            color: $green;
        }
    }
    .offline {
        span {
            color: $gray-word;
        }
    }
    img {
        position: relative;
        vertical-align: top;
        top: 18px;
        margin-right: 4px;
    }
}
.gray-color {
    color: $gray-word;
}
</style>
